<div class="app__attributes-dialog dialog-container m-t[-10px] pt-[8px]">
  <div class="app__attributes-dialog-header">
    <p class="app__attributes-dialog-title">{{ 'Manage Tags' }}</p>
    <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
      <span class="material-icons icons-close-mobile icons-close-mobile font-semibold text-2xl">close</span>
    </button>
  </div>
  <form style="margin: auto; width: 90%; display: flex; flex-direction: column; width: 90%" [formGroup]="vaultTagForm">
    <!-- <mat-form-field appearance="fill" style="width: 100% !important" [class]="'automtic-form-desing-form-only add-automtic-form-desing full-width'">
      <mat-label class="automtic-form-desing-lable"> Year </mat-label>
      <mat-select [formControlName]="'year'" disableOptionCentering (selectionChange)="setvalueTo($event.value, 'year')">
        @for (year of years; track year) {
        <mat-option [value]="year">
          {{ year }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field> -->

    <mat-form-field appearance="fill" style="width: 100% !important" [class]="'automtic-form-desing-form-only add-automtic-form-desing full-width'">
      <mat-label class="automtic-form-desing-lable"> Document Tags </mat-label>
      <mat-select
        [formControlName]="'document_type'"
        disableOptionCentering
        panelClass="app__inline--mat--select--dropdown"
        (selectionChange)="setValue($event.value, 'document_type')"
        multiple
      >
        <div class="py-2 px-4 bg-white app__tags--input mt-1">
          <div class="app__discovery--header--search--field w-full h-9">
            <div class="app__centered-item w-full h-full px-2 py-1">
              <span class="mt-[-2px] text-[#5475C0]">
                <img src="assets/images/blue-search-icon.svg" width="16px" height="16px" />
              </span>
              <input
                class="h-full w-full ml-2 border-none outline-none text-[13px] italic"
                type="text"
                [(ngModel)]="searchText"
                placeholder="Search"
                (input)="onInputChange($event.target.value)"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                (keydown)="handleKeyDown($event)"
              />
            </div>
          </div>
        </div>

        <div class="app__tags--input py-1 px-4" [ngClass]="{ 'bg-[#EBF0FA]': isTagInputShown, 'bg-white': !isTagInputShown }" (click)="$event.stopPropagation()">
          @if(!isTagInputShown){
          <div
            class="app__attributes-dialog-title flex items-center text-center font-semibold text-[13px] text-[#25508E] hover:cursor-pointer gap-1"
            (click)="isTagInputShown = true"
          >
            <span class="text-2xl">+</span> Add Custom tag
          </div>
          } @else {
          <div>
            <div class="relative w-[290px] h-[40px] bg-white">
              <div class="app__discovery--header--search--field w-full h-full">
                <div class="app__centered-item w-full h-full px-1 py-1">
                  <input
                    class="w-full h-full border-none outline-none text-[12px] ml-2"
                    type="text"
                    maxlength="30"
                    placeholder="Custom Tag"
                    (input)="onCustomTagNameInputChange($event.target.value)"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                    (keydown)="handleKeyDown($event)"
                    (keyup)="$event.stopPropagation()"
                    (keypress)="$event.stopPropagation()"
                  />
                </div>
              </div>
              <div class="flex">
                <span
                  class="absolute right-[53px] top-1/2 transform -translate-y-1/2 text-[#5475C0] hover:cursor-pointer"
                  (click)="isTagInputShown = false; customTagName = ''"
                >
                  <img src="assets/images/inbox/custom-close-icon.svg" />
                </span>
                <button
                  type="button"
                  class="absolute right-2 top-1/2 transform -translate-y-1/2"
                  (click)="addUserTags()"
                  [disabled]="customTagName.length === 0"
                  [class]="
                    customTagName.length === 0
                      ? 'app__btn--disabled w-fit px-2 py-[2px] mb-0 mt-0 rounded text-[12px]'
                      : 'app__btn--primary  w-fit px-2 py-[2px] mb-0 mt-0 rounded text-[12px]'
                  "
                >
                  Add
                </button>
              </div>
            </div>
            @if(errorMessage){
            <span class="text-red-500 text-[12px]"> {{ errorMessage }} </span>
            }
          </div>
          }
        </div>
        @for (documentType of filteredDocumentTypes; track documentType) {
        <mat-option [value]="documentType">
          {{ documentType | titlecase }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field appearance="fill" style="width: 100% !important" [class]="'automtic-form-desing-form-only add-automtic-form-desing full-width'">
        <mat-label class="automtic-form-desing-lable"> Version </mat-label>
        <mat-select [formControlName]="'version'" disableOptionCentering (selectionChange)="setvalueTo($event.value, 'version')">
          @for (version of versions; track version) {
            <mat-option [value]="version"> {{ version }} </mat-option>
          }
        </mat-select>
      </mat-form-field> -->
  </form>

  <div class="app__attributes-dialog-cta" style="border-top: 0px !important">
    <button
      mat-raised-button
      type="submit"
      (click)="addTagValue()"
      [disabled]="vaultTagForm.invalid"
      [class]="vaultTagForm.valid ? 'app__btn--primary mb-0 mt-0 rounded-lg' : 'app__btn--disabled mb-0 mt-0 rounded-lg'"
    >
      {{ 'Add' }}
    </button>
  </div>
</div>
